import { render, staticRenderFns } from "./TransactionPayout.vue?vue&type=template&id=34fd2cdc&"
import script from "./TransactionPayout.vue?vue&type=script&lang=ts&"
export * from "./TransactionPayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports